<template>
  <div>
    <h5 v-if="loading" style="text-align:center; width:100%">
      Loading...
    </h5>
    <h3 v-if="error">
      {{ error }}
    </h3>
    <!-- <edit-profile-form :person="person" /> -->
    <div class="card" v-if="!loading && !error">
      <div class="card-header">
        <h4 class="title">
          Edit Profile
        </h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="First Name"
              placeholder="First Name"
              v-model="first_name"
              v-if="person"
              required
            />
          </div>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Last Name"
              placeholder="Last Name"
              v-model="last_name"
              v-if="person"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <el-tooltip style="display: inline; max-width: 5px;" effect="dark" placement="top-start">
              <div slot="content">
                If this person has been added into<br />
                discipleship, by changing this email, <br />
                you are updating the email associated <br />
                with their FOCUS OneLogin account.
              </div>
              <span><i class="el-icon-info" style="margin-left: 10px;" /> </span>
            </el-tooltip>
            <fg-input
              type="text"
              style="display: inline"
              label=" Email (non .edu)"
              placeholder="Email"
              v-model="email"
              v-if="person"
            />
          </div>
          <div class="col-md-4">
            <fg-input
              type="text"
              label="Email (optional .edu)"
              placeholder="Email"
              v-model="email2"
              v-if="person"
            />
          </div>
          <div class="col-md-4">
            <fg-input
              type="text"
              label="Phone"
              placeholder="Phone"
              v-model="phone"
              v-if="person"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="control-label">
              Gender
              <span class="text-danger">*</span>
            </label>
            <fg-input>
              <el-select
                class="select-default"
                size="large"
                placeholder="Gender"
                v-model="gender_id"
                v-if="person"
                filterable
              >
                <el-option
                  v-for="genderOption in genderOptions"
                  class="select-default"
                  :key="genderOption.id"
                  :label="genderOption.name"
                  :value="genderOption.id"
                />
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-6" v-if="notParishAlumni">
            <label class="control-label">
              School Year
              <span v-if="notParishAlumni" class="text-danger">*</span>
            </label>
            <fg-input>
              <el-select
                class="select-default"
                size="large"
                placeholder="School Year"
                v-model="school_year_id"
                v-if="person"
                filterable
              >
                <el-option
                  v-for="schoolYearOption in schoolYearOptions"
                  class="select-default"
                  :key="schoolYearOption.id"
                  :label="schoolYearOption.name"
                  :value="schoolYearOption.id"
                />
              </el-select>
            </fg-input>
          </div>
        </div>
        <div class="row" v-if="notParishAlumni">
          <div class="col-sm-6">
            <label>
              Does this person play a varsity sport?
              <span v-if="notParishAlumni" class="text-danger">*</span>
            </label>
            <p-radio
              v-model="is_varsity"
              v-if="person"
              :value="1"
              :label="true"
            >
              Yes
            </p-radio>
            <p-radio
              v-model="is_varsity"
              v-if="person"
              :value="0"
              :label="false"
            >
              No
            </p-radio>
          </div>
          <div class="col-sm-6">
            <label>
              Is this person in a fraternity or sorority?
              <span v-if="notParishAlumni" class="text-danger">*</span>
            </label>
            <p-radio
              v-model="is_greek"
              v-if="person"
              :value="1"
              :label="true"
            >
              Yes
            </p-radio>
            <p-radio
              v-model="is_greek"
              v-if="person"
              :value="0"
              :label="false"
            >
              No
            </p-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" v-if="person.show_text_2_report">
            <label>Do you want to sign up for text reminders to submit bible study attendance? Check this box!
              <br><span v-if="phone == '' || phone == null">(You must have a phone number to check this box!)</span>
              <br><span v-if="is_text_2_report">You will be texted at the end of your study
                based on the <b>timezone of your campus</b>!</span>
            </label>
            <p-checkbox v-model="is_text_2_report" :disabled="phone == '' || phone == null" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" v-if="person && isOneOfTheseRoles(['admin', 'superadmin'])">
            <label class="control-label">Role</label>
            <fg-input>
              <el-select
                class="select-default"
                size="large"
                placeholder="Role"
                v-model="role_id"
                filterable
              >
                <el-option
                  v-for="roleOption in roleOptions"
                  class="select-default"
                  :key="roleOption.id"
                  :label="roleOption.title"
                  :value="roleOption.id"
                />
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-6" v-if="person && isOneOfTheseRoles(['admin', 'superadmin'])">
            <label class="control-label">Location</label>
            <fg-input>
              <el-select
                class="select-default"
                size="large"
                placeholder="Location"
                v-model="location_id"
                filterable
              >
                <el-option
                  v-for="locationOption in locationOptions"
                  class="select-default"
                  :key="locationOption.id"
                  :label="locationOption.name"
                  :value="locationOption.id"
                />
              </el-select>
            </fg-input>
          </div>
        </div>
        <div>
          <label class="control-lable">My notes</label>
          <el-input
            type="textarea"
            placeholder="Notes"
            v-model="user_notes_on_person"
          />
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click="handleSave()">
            Update Profile
          </button>
          <br>
          <span v-if="validationError === true" style="color: red;">
            Missing fields.
            <p v-if="notParishAlumni && !isAdmin">
              Make sure first name, last name, Varsity Catholic, Greek, school year, and gender are filled out.
            </p>
            <p v-else>Make sure first name, last name, and gender are filled out.</p>
          </span>
        </div>
      </div> <!-- card body -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import {
    mapState, mapActions, vuex, mapGetters
} from 'vuex';
import {
    DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option
} from 'element-ui';
// import EditProfileForm from '../../components/People/EditProfileForm.vue';

const data = 'People';
function validateForm(notParishAlumni, isAdmin, firstName, lastName, genderId, schoolYearId, isVarsity, isGreek) {
    if (notParishAlumni && !isAdmin) {
        return !!firstName && !!lastName && !!genderId && !!schoolYearId && isVarsity !== '' && isGreek !== '';
    }
    // Else is parish/alumni
    return !!firstName && !!lastName && !!genderId;
}

export default {
    data() {
        return {
            title: 'PersonEdit',
            namespace: 'People',
            first_name: '',
            last_name: '',
            email: '',
            email2: '',
            phone: '',
            gender_id: '',
            school_year_id: '',
            is_varsity: '',
            is_greek: '',
            user_notes_on_person: null,
            validationError: false,
            role_id: '',
            location_id: '',
            is_text_2_report: '',
            loading: false,
            error: ''
        };
    },
    computed: {
        ...mapState({
            person: (state) => state.People.person,
            // error: (state) => state.People.error,
            genderOptions: (state) => state.People.genders,
            schoolYearOptions: (state) => state.People.schoolYears,
            roleOptions: (state) => state.People.roles,
            locationOptions: (state) => state.People.locations
        }),
        notParishAlumni() {
            return !this.isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])
              || this.isOneOfTheseRoles(['admin']);
        },
        isAdmin() {
            return this.isOneOfTheseRoles(['admin']);
        }
    },
    methods: {
        getPersonById() {
            this.loading = true;
            this.$store.dispatch(`${this.namespace}/getPersonById`,
                { personId: this.$route.params.id })
                .then(() => {
                    this.first_name = this.person.first_name;
                    this.last_name = this.person.last_name;
                    this.email = this.person.email;
                    this.email2 = this.person.email2;
                    this.phone = this.person.phone;
                    this.gender_id = this.person.gender_id;
                    this.school_year_id = this.person.school_year_id;
                    this.is_varsity = this.person.is_varsity;
                    this.is_greek = this.person.is_greek;
                    this.user_notes_on_person = this.person.user_notes_on_person;
                    this.is_text_2_report = this.person.is_text_2_report;
                    if (this.isOneOfTheseRoles(['admin', 'superadmin'])) {
                        this.role_id = this.person.primary_role_id;
                        this.location_id = this.person.primary_location_id;
                    }
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },
        handleSave() {
            this.loading = true;
            this.validationError = false;
            if (!validateForm(this.notParishAlumni, this.isAdmin, this.first_name, this.last_name, this.gender_id,
                this.school_year_id, this.is_varsity, this.is_greek)) {
                this.validationError = true;
                this.loading = false;
                return;
            }
            this.$store.dispatch(`${this.namespace}/updatePerson`, {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email ? this.email.toLowerCase() : '',
                email2: this.email2 ? this.email2.toLowerCase() : '',
                phone: this.phone,
                gender_id: this.gender_id,
                school_year_id: this.school_year_id,
                person_id: this.person.id,
                is_varsity: this.is_varsity,
                is_greek: this.is_greek,
                user_notes_on_person: this.user_notes_on_person,
                is_text_2_report: this.is_text_2_report,
                primary_role_id: this.role_id,
                primary_location_id: this.location_id
            })
                .then(() => {
                    this.$router.push({ name: 'PersonShow', params: { id: this.$route.params.id } });
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    this.$message(error.response.data.message);
                });
        },
        getGenders() {
            this.$store.dispatch(`${this.namespace}/getGenders`);
        },
        getSchoolYears() {
            this.$store.dispatch(`${this.namespace}/getSchoolYears`);
        },
        getLocations() {
            this.$store.dispatch(`${this.namespace}/getLocations`);
        },
        getRoles() {
            this.$store.dispatch(`${this.namespace}/getRoles`);
        },
    },
    created() {
        //
        // this.getPersonById();
        // this.first_name = this.person.first_name;
        // this.last_name = this.person.last_name;
        // this.email = this.person.email;
        // this.email2 = this.person.email2;
        // this.phone = this.person.phone;
        // this.gender_id = this.person.gender_id;
        // this.school_year_id = this.person.school_year_id;
        // this.is_varsity = this.person.is_varsity;
        // this.is_greek = this.person.is_greek;
        // this.getGenders();
        // this.getSchoolYears();
        // this.$store.commit('People/setError', '');
    },
    mounted() {
        this.getPersonById();
        // this.first_name = this.person.first_name;
        // this.last_name = this.person.last_name;
        // this.email = this.person.email;
        // this.email2 = this.person.email2;
        // this.phone = this.person.phone;
        // this.gender_id = this.person.gender_id;
        // this.school_year_id = this.person.school_year_id;
        // this.is_varsity = this.person.is_varsity;
        // this.is_greek = this.person.is_greek;
        this.getGenders();
        this.getSchoolYears();
        this.getRoles();
        this.getLocations();
        this.$store.commit('People/setError', '');
    },
    beforeDestroy() {
        // todo destroy the state.
    }
};
</script>
<style>
.el-select {
    width: 100%;
  }
</style>
